/*
 * bundle-guard.js
 *
 * Keeps Turapura Duo pricing consistent:
 * - one serum alone or one cream alone stays at the Base price;
 * - one Base serum + one Base cream is automatically converted to one Duo pair;
 * - a discounted Bundle variant is reverted to Base if its partner is removed;
 * - only one discounted Bundle line is allowed per cart.
 */
(function () {
  'use strict';

  var BUSY = false;
  var IDS = {
    serumProduct: 14938048987247,
    creamProduct: 14944698564719,
    serumBase: 53090653601903,
    serumBundle: 54156341903471,
    creamBase: 53090652717167,
    creamBundle: 54156342165615
  };

  function cartElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function sectionIds() {
    var el = cartElement();
    if (!el || typeof el.getSectionsToRender !== 'function') return [];
    return el.getSectionsToRender().map(function (s) { return s.section || s.id; });
  }

  function render(data) {
    var el = cartElement();
    if (!el || !data || !data.sections) return;
    try {
      if (typeof el.renderContents === 'function') el.renderContents(data);
      if (el.classList) el.classList.remove('is-empty');
    } catch (e) {}
  }

  function post(path, body) {
    return fetch(window.Shopify.routes.root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (data) {
        throw new Error(data.description || data.message || 'Cart update failed');
      });
      return res.json();
    });
  }

  function addVariant(variantId, properties) {
    var item = { id: variantId, quantity: 1 };
    if (properties) item.properties = properties;
    return post('cart/add.js', { items: [item] });
  }

  function changeLine(key, quantity) {
    var ids = sectionIds();
    return post('cart/change.js', {
      id: key,
      quantity: Math.max(0, quantity),
      sections: ids.length ? ids : undefined,
      sections_url: window.location.pathname
    });
  }

  function bundleMeta(item) {
    var props = item.properties || {};
    var variantId = Number(item.variant_id);

    if (variantId === IDS.serumBundle) {
      return {
        baseVariant: IDS.serumBase,
        partnerProduct: Number(props._bundle_partner_product) || IDS.creamProduct
      };
    }
    if (variantId === IDS.creamBundle) {
      return {
        baseVariant: IDS.creamBase,
        partnerProduct: Number(props._bundle_partner_product) || IDS.serumProduct
      };
    }
    return null;
  }

  function findIssue(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;

    var productQty = {};
    var hasBundle = false;
    var serumBaseLine = null;
    var creamBaseLine = null;

    cart.items.forEach(function (item) {
      var productId = Number(item.product_id);
      var variantId = Number(item.variant_id);
      productQty[productId] = (productQty[productId] || 0) + Number(item.quantity || 0);

      if (variantId === IDS.serumBundle || variantId === IDS.creamBundle) hasBundle = true;
      if (!serumBaseLine && variantId === IDS.serumBase && item.quantity > 0) serumBaseLine = item;
      if (!creamBaseLine && variantId === IDS.creamBase && item.quantity > 0) creamBaseLine = item;
    });

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var meta = bundleMeta(item);
      if (!meta) continue;

      if (!productQty[meta.partnerProduct]) {
        return {
          type: 'replace',
          key: item.key,
          oldQuantity: Number(item.quantity || 1),
          newVariant: meta.baseVariant,
          properties: null
        };
      }

      if (Number(item.quantity || 0) > 1) {
        return { type: 'clamp', key: item.key, quantity: 1 };
      }
    }

    if (!hasBundle && serumBaseLine && creamBaseLine) {
      return {
        type: 'replace',
        key: creamBaseLine.key,
        oldQuantity: Number(creamBaseLine.quantity || 1),
        newVariant: IDS.creamBundle,
        properties: {
          '_pdrn_duo': '1',
          '_bundle_partner_product': String(IDS.serumProduct),
          '_bundle_base_variant': String(IDS.creamBase)
        }
      };
    }

    return null;
  }

  function applyIssue(issue) {
    if (issue.type === 'clamp') return changeLine(issue.key, issue.quantity);

    return addVariant(issue.newVariant, issue.properties).then(function () {
      return changeLine(issue.key, issue.oldQuantity - 1);
    });
  }

  function publishUpdate(data) {
    render(data);
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-guard', cartData: data });
    }
  }

  function runGuard() {
    if (BUSY) return Promise.resolve();
    BUSY = true;

    return fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var issue = findIssue(cart);
        if (!issue) return null;
        return applyIssue(issue);
      })
      .then(function (data) {
        if (data) publishUpdate(data);
        BUSY = false;
        if (data) return runGuard();
      })
      .catch(function (err) {
        BUSY = false;
        console.error('[bundle-guard] failed:', err);
      });
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (evt && evt.source === 'bundle-guard') return;
        runGuard();
      });
    }
    document.addEventListener('cart:item-added', runGuard);
    runGuard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();